import { render, staticRenderFns } from "./supplierInfo.vue?vue&type=template&id=c2943a38&scoped=true"
import script from "./supplierInfo.vue?vue&type=script&lang=js"
export * from "./supplierInfo.vue?vue&type=script&lang=js"
import style0 from "./supplierInfo.vue?vue&type=style&index=0&id=c2943a38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2943a38",
  null
  
)

export default component.exports